import classNames from 'classnames';
import css from './FormCheckbox.module.scss';
import { BaseFormControlLabel } from '../../Form/BaseFormControlLabel/BaseFormControlLabel';
import { FormCheckboxProps } from './FormCheckbox.types';
import Checkbox from '../Checkbox/Checkbox';
import { GMTitle } from '../../Title';

/**
 * A checkbox with label control that allows significant control over the style and placement
 * of the label being displayed.
 *
 * @param title - {@link FormCheckboxProps.title title} description.
 * @param errorClassName - {@link FormCheckboxProps.errorClassName errorClassName} description.
 * @param label - {@link FormCheckboxProps.label label} description.
 * @param labelPlacement - {@link FormCheckboxProps.labelPlacement labelPlacement} description. (default: 'end')
 * @param labelVariant - {@link FormCheckboxProps.labelVariant labelVariant} description. (default: 'none')
 * @param extraLabelWidth - {@link FormCheckboxProps.extraLabelWidth extraLabelWidth} description. (default: false)
 * @param checked - {@link FormCheckboxProps.checked checked} description. (default: false)
 * @param disabled - {@link FormCheckboxProps.disabled disabled} description. (default: false)
 * @param onChange - {@link FormCheckboxProps.onChange onChange} description.
 * @param required - {@link FormCheckboxProps.required required} description.
 */
const FormCheckbox = ({
    title,
    errorClassName,
    label,
    labelPlacement = 'end',
    extraLabelWidth = false,
    labelVariant = 'none',
    checked = false,
    disabled = false,
    onChange,
    required,
}: FormCheckboxProps) => {
    return (
        <BaseFormControlLabel
            classes={{
                root: classNames(css.wrapper, extraLabelWidth ? css.extraLabelWidth : undefined),
                labelPlacementStart: css.labelPlacementStart,
                error: errorClassName,
            }}
            control={
                <Checkbox
                    title={title}
                    checked={checked}
                    disabled={disabled}
                    onChange={onChange}
                    iconSize={'medium'}
                />
            }
            label={
                label ? (
                    labelVariant === 'heading' ? (
                        <GMTitle className={css.titleWrap} headerLevel={5}>
                            {label}
                        </GMTitle>
                    ) : (
                        <span
                            role={'presentation'}
                            aria-label={'checkbox-label'}
                            className={labelVariant === 'themed' ? css.labelTheme : undefined}
                        >
                            {label}
                        </span>
                    )
                ) : null
            }
            labelPlacement={labelPlacement}
            required={required}

        />
    );
};

export default FormCheckbox;